const DraggableMixin = require('../../mixins/draggable');
const EditorFacade = require('../../../../../facade/editor/editor');
const DesignFacade = require('../../../../../facade/design/design');
const { constants } = require('@config');

module.exports = Backbone.mixin(Backbone.mixin(Backbone.View.extend({
  template: require('../templates/base.hbs'),
  elementType: '',
  height: 86,
  width: 122.5,
  fineSize: null,

  events: {
    'touchstart .item': 'mouseDown',
    'mousedown .item': 'mouseDown'
  },

  getClickElementData: function (event) {
    const placeholder = this.el.querySelector('img');
    const bb = (placeholder || this.el).getBoundingClientRect();

    const width = this.fineSize?.width || bb.width;
    const height = this.fineSize?.height || bb.height;

    let scale = Math.min(this.canvas.contentW, this.canvas.contentH);
    scale /= Math.max(width, height);

    return {
      position: {
        x: (this.canvas.contentW - width * (scale / 2)) / 2,
        y: (this.canvas.contentH - height * (scale / 2)) / 2
      },
      size: {
        width: width * (scale / 2),
        height: height * (scale / 2)
      }
    };
  },

  getMouseUpElementData: function (event) {
    const bb = this.$draggableClone.get(0).getBoundingClientRect();
    const zoom = EditorFacade.handle('zoom', 'get');
    const offset = this.editor.getOffset();

    const width = this.fineSize?.width || bb.width;
    const height = this.fineSize?.height || bb.height;

    return {
      position: {
        x: Math.floor4((bb.left - offset.x) / zoom),
        y: Math.floor4((bb.top - offset.y) / zoom)
      },
      size: {
        width: Math.floor4(width / zoom),
        height: Math.floor4(height / zoom)
      }
    };
  },

  clickEvent: function (event) {
    if (this.canvas.getMode() === 'textedit') {
      this?.updateContent(this.getClickElementData(event), event.target);
      return;
    }

    this.addElement(this.getClickElementData(event), event.target);
  },

  mouseUpEvent: function (event) {
    this.addElement(_.extend(
      this.getMouseUpElementData(event),
      { selected: true }
    ));
  },

  addElement: function (elementData) {
    const element = this.editor.addElement(this.elementType, elementData);
    INKIVE.Tool.blinkScreen(element);
  },

  initialize: function () {
    _.bindAll(this, 'resize');
    this.editor = INKIVE.Tool.getInstance().editor;
    this.canvas = this.editor.canvas;

    this.render();
    this.initDraggable();
  },

  render: function () {
    const html = this.template(this.getTemplateRenderData());

    this.$el.html(html);
    this.width && this.$el.css('width', this.width);
    this.height && this.$el.css('height', this.height);
    this.$draggable = this.$el.find('a.item');
  },

  remove: function () {
    this.undelegateEvents();
    this.$el.removeData().unbind();
    Backbone.View.prototype.remove.call(this);
  },

  resize: function () {
    const height = this.$el.find('img').height();
    this.$el.height(height);
    this.trigger('resize');
  },

  getTemplateRenderData: function () {},

  replaceElement: function () {
    const selectedElements = this.canvas.getSelectedElems();
    const $selectedElement = selectedElements.length === 1 ? $(selectedElements[0]) : null;

    if ($selectedElement && $selectedElement.is(this.replaceType) && $selectedElement.is('.element')) {
      const bbox = $selectedElement[0].getBBox();
      const size = Math.max(bbox.width, bbox.height);

      this.replaceData.size = this.replaceData.size || {
        width: size,
        height: size
      };
      this.replaceData.position = {
        x: bbox.x,
        y: bbox.y
      };
      $selectedElement.is('.sticker') && $selectedElement.removeClass('sticker').addClass('icon');

      selectedElements[0].removeAttribute(constants.smartAssets.attributes.definedAsset);
      selectedElements[0].removeAttribute(constants.smartAssets.attributes.userInput);

      DesignFacade.set($selectedElement.attr('id'), this.replaceData);
    }
  },

  retryImage: function (url) {
    return fetch(url, { method: 'HEAD' })
      .then(response => {
        if (!response.ok) throw new Error('Image not found');

        return url;
      });
  }
}), Backbone.Events), DraggableMixin);
